import React from 'react';

export default ({fill}) => (
    <svg width="20" height="20" viewBox="0 0 18 18"  fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 0V15H9V0H6ZM9 2L13 15L16 14L12 1L9 2ZM2 2V15H5V2H2ZM0 16V18H18V16H0Z" fill={fill}/>
    </svg>

)